import { WhmBox, WhmThemeProvider } from "@securitize/reactjs-whm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nContextProvider } from "../../contexts/I18nContext";
import PulsatingSpinner from "../../components/shared/PulsatingSpinner";

export interface MFEContainerProps {
  language: string;
  theme?: "LIGHT" | "DARK";
  languageLoadingComponent?: React.ReactNode;
  cssBaseline?: "CssBaseline" | "ScopedCssBaseline" | "none";
}

export type MFEProps<T> = MFEContainerProps & T;

const queryProvider = new QueryClient({
  defaultOptions: {
    queries: {
      // We don't want to refetch every time the window is focused
      refetchOnWindowFocus: false,
    },
  },
});

export default function MFEContainer({
  children,
  language,
  theme,
  languageLoadingComponent,
  cssBaseline = "ScopedCssBaseline",
}: MFEContainerProps & { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryProvider}>
      <I18nContextProvider
        language={language}
        loadingComponent={
          languageLoadingComponent ?? (
            <WhmBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
              }}
            >
              <PulsatingSpinner />
            </WhmBox>
          )
        }
      >
        <WhmThemeProvider cssBaseline={cssBaseline} dark={theme === "DARK"}>
          {children}
        </WhmThemeProvider>
      </I18nContextProvider>
    </QueryClientProvider>
  );
}
